import { paths } from '@mc/paths'
import { PROMO_BANNER_GIFT_ENTRY_SOURCE } from '../../lib/constants'

// https://app.growthbook.io/features/pen-7680_v1
export const PROMO_BANNER_GIFT_CTA_FLAG_NAME = 'pen-7680_v1'

export const GIFT_CTA_ACTION = 'Gift'

export const GIFT_CTA_HREF = `${paths.promotion}?entry_source=${PROMO_BANNER_GIFT_ENTRY_SOURCE}`
